import React, { useState, useEffect, useCallback } from 'react';
import {
  Box,
  Typography,
  Card,
  CardContent,
  Grid,
  Button,
  TextField,
  InputAdornment,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Chip,
  Avatar,
  Pagination,
  Stack,
  IconButton,
  MenuItem,
  Select,
  FormControl,
  CircularProgress,
  Popover,
} from '@mui/material';
import {
  Search,
  Notifications,
  LocalShipping,
  Restaurant,
  TakeoutDining,
  Mail,
  Celebration,
  AccessTime,
  Circle,
  CheckCircle,
  MoreVert,
  FilterList,
  ArrowForward,
  CalendarToday,
  DoneAll
} from '@mui/icons-material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { get_notifications, update_notifications, get_notifications_count, read_all_notifications } from '../services/notificationService';
import { useRestaurant } from '../contexts/RestaurantContext';
import { useNavigate } from 'react-router-dom';
import outletService from '../services/outletService';
import { useNotification } from '../contexts/NotificationContext';

const NotificationManagement = ({
  notificationReload, setNotificationReload, notificationCount,
  deliveryNotificationCount,
  setDeliveryNotificationCount,
  takeawayNotificationCount,
  setTakeawayNotificationCount,
  cateringNotificationCount,
  setCateringNotificationCount,
  reservationNotificationCount,
  setReservationNotificationCount}) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [dateFilter, setDateFilter] = useState('all');
  const [outletFilter, setOutletFilter] = useState('all');
  const [typeFilter, setTypeFilter] = useState('all');
  const [isReadFilter, setIsReadFilter] = useState('all');
  const [adminOutlets, setAdminOutlets] = useState([])
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [notificationClick, setNotificationClick] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [loading, setLoading] = useState(false);
  const [dateRange, setDateRange] = useState({
    startDate: null,
    endDate: null
  });
  const [datePickerAnchorEl, setDatePickerAnchorEl] = useState(null);
  const rowsPerPageOptions = [5, 10, 25, 50];
  const [notificationData, setNotificationData] = useState([]);
  const [readAllNotification, setReadAllNotification] = useState(false)
  const { outlets, setNotificationCount } = useRestaurant();
  const navigate = useNavigate();
  const { showSuccess, showError } = useNotification()

  const fetchNotifications = useCallback(async () => {



    let admin_check = JSON.parse(localStorage.getItem('admin_outlet_id'))

    if (admin_check) {
      setOutletFilter(admin_check)
    }
    setLoading(true);

    // Build query params
    const params = {
      page: page,
      limit: rowsPerPage
    };

    // Add filters only if not 'all'
    if (dateFilter !== 'all') {
      // console.log("Start DateRange => ", dateRange.startDate);
      // console.log("End DateRange => ", dateRange.endDate);
      if (dateFilter === 'custom' && dateRange.startDate && dateRange.endDate) {
        // Format dates for API (YYYY-MM-DD)
        const formatDate = (date) => {
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const day = String(date.getDate()).padStart(2, '0');
          return `${year}-${month}-${day}`;
        };
        params.from_date = formatDate(dateRange.startDate);
        params.to_date = formatDate(dateRange.endDate);
      } else {
        params.date_filter = dateFilter;
      }
    }

    if (admin_check) {
      params.outlet_id = parseInt(admin_check);
    } else if (outletFilter !== 'all') {
      params.outlet_id = parseInt(outletFilter);
    }

    if (typeFilter !== 'all') {
      params.order_type = typeFilter.toLowerCase();
    }

    if (isReadFilter !== 'all') {
      params.is_read = isReadFilter === 'read';
    }

    // Add search query if needed
    if (searchQuery.trim() !== '') {
      params.search = searchQuery.trim();
    }

    // console.log("API Params => ", params);

    try {
      const response = await get_notifications(params);
      // console.log("Notification Data => ", response);

      // Set the notification data
      setNotificationData(response.data || []);

      // Handle different API response structures
      if (response.total !== undefined) {
        // If API returns total count
        setTotalCount(response.total);
        setTotalPages(Math.ceil(response.total / rowsPerPage));
      } else if (response.pages !== undefined) {
        // If API returns total pages
        setTotalPages(response.pages);
        setTotalCount(response.total || response.data?.length || 0);
      } else if (response.meta && response.meta.total) {
        // If API returns meta with total
        setTotalCount(response.meta.total);
        setTotalPages(Math.ceil(response.meta.total / rowsPerPage));
      } else {
        // Fallback - assume the data array contains all filtered results
        // Note: This is not ideal for large datasets
        setTotalCount(response.data?.length || 0);
        setTotalPages(Math.ceil((response.data?.length || 0) / rowsPerPage));
      }
    } catch (error) {
      // console.error("Error getting notifications", error);
      setNotificationData([]);
      setTotalCount(0);
      setTotalPages(1);
    } finally {
      setLoading(false);
    }
  }, [dateFilter, dateRange, outletFilter, typeFilter, isReadFilter, rowsPerPage, page, searchQuery, readAllNotification]);

  // Fetch notifications when filters or pagination changes
  useEffect(() => {
    fetchNotifications();
  }, [fetchNotifications]);


  useEffect(() => {
    async function fetchAdminOutlets() {
      try {
        const response = await outletService.getOutlets()
        setAdminOutlets(response)
      }
      catch (error) {
        // console.error(error)
      }
    }
    fetchAdminOutlets()

    let admin_check = JSON.parse(localStorage.getItem('admin_outlet_id'))

    if (admin_check) {
      setOutletFilter(admin_check)
    }


  }, [])

  // Fetch notifications count on component mount
  useEffect(() => {
    const fetchNotificationCount = async () => {
      try {
        const notification_count = await get_notifications_count();
        setNotificationCount(notification_count.unread || 0);
      } catch (error) {
        // console.error("Error fetching notification count", error);
      }
    };
    fetchNotificationCount();
  }, [setNotificationCount]);

  const handleRowsPerPageChange = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    setRowsPerPage(newRowsPerPage);
    setPage(1); // Reset to first page when rows per page changes
  };

  const handlePageChange = (event, value) => {
    // console.log("Page changed to => ", value);
    setPage(value);
  };

  const handleNotificationRead = async (id, order_type, outlet_id) => {
    try {
      const response = await update_notifications(id);
      const notification_count = await get_notifications_count();
      // console.log(response);
      setNotificationClick(!notificationClick);
      setNotificationCount(notification_count.unread || 0);

      // console.log("order_type Clicking => ", order_type);
      // console.log("outlet_type Clicking => ", outlet_id);
      if (order_type === "CATERING") {
        navigate('/admin/catering')
      }
      else if (order_type === "RESERVATION") {
        navigate('/admin/tables')
      }
      else {
        navigate('/admin/delivery', {
          state: {
            notification_type_clicked: order_type,
            outlet: outlet_id
          }
        });
      }

    } catch (error) {
      // console.error(error.message);
    }
  };

  const getTypeIcon = (type) => {
    switch (type) {
      case 'DELIVERY': return <LocalShipping fontSize="small" />;
      case 'RESERVATION': return <Restaurant fontSize="small" />;
      case 'TAKEAWAY': return <TakeoutDining fontSize="small" />;
      case 'CONTACT': return <Mail fontSize="small" />;
      case 'CATERING': return <Celebration fontSize="small" />;
      default: return <Notifications fontSize="small" />;
    }
  };

  const getTypeColor = (type) => {
    switch (type) {
      case 'DELIVERY': return 'primary';
      case 'RESERVATION': return 'secondary';
      case 'TAKEAWAY': return 'success';
      case 'CONTACT': return 'info';
      case 'CATERING': return 'warning';
      default: return 'default';
    }
  };

  const clearFilters = () => {
    setSearchQuery('');
    setDateFilter('all');
    if (JSON.parse(localStorage.getItem('admin_outlet_id'))) {
      setOutletFilter(JSON.parse(localStorage.getItem('admin_outlet_id')));
    }
    else {
      setOutletFilter('all')
    }
    setTypeFilter('all');
    setIsReadFilter('all');
    setDateRange({ startDate: null, endDate: null });
    setPage(1);
  };

  const handleDateFilterChange = (event) => {
    const value = event.target.value;
    setDateFilter(value);
    setPage(1);

    // Clear date range if not custom
    if (value !== 'custom') {
      setDateRange({ startDate: null, endDate: null });
    }
  };

  const handleDateRangeApply = () => {
    setDatePickerAnchorEl(null);
    setPage(1);
  };

  const handleDateRangeCancel = () => {
    setDateRange({ startDate: null, endDate: null });
    setDateFilter('all');
    setDatePickerAnchorEl(null);
  };

  const startIndex = (page - 1) * rowsPerPage + 1;
  const endIndex = Math.min(page * rowsPerPage, totalCount);

  const openDatePicker = Boolean(datePickerAnchorEl);
  const datePickerId = openDatePicker ? 'date-picker-popover' : undefined;

  const handleReadAll = async () => {
    try {
      const response = await read_all_notifications();
      let update = !readAllNotification
      showSuccess("Notification Updated Successfully")
      setReadAllNotification(update)

      // Fetch updated counts
      const notification_count = await get_notifications_count();

      // Update the context values
      setNotificationCount(notification_count.unread || 0);

      // Update root notification counts for sidebar
      if (setNotificationCount) {
        setNotificationCount(notification_count.unread || 0);
      }
      if (setDeliveryNotificationCount) {
        setDeliveryNotificationCount(notification_count.delivery_unread || 0);
      }
      if (setTakeawayNotificationCount) {
        setTakeawayNotificationCount(notification_count.takeaway_unread || 0);
      }
      if (setCateringNotificationCount) {
        setCateringNotificationCount(notification_count.catering_unread || 0);
      }
      if (setReservationNotificationCount) {
        setReservationNotificationCount(notification_count.reservation_unread || 0);
      }

      // Trigger sidebar refresh
      setNotificationReload(!notificationReload);

    } catch (error) {
      // console.error("Error While Reading Notification", error);
      showError("Failed to mark all notifications as read");
    }
  }

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Box sx={{ maxWidth: 1200, mx: 'auto', p: 3 }}>
        {/* Header Section */}
        <Box sx={{ mb: 4 }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
            <Box>
              <Typography variant="h4" fontWeight="bold" color="primary">
                Notifications
              </Typography>
              <Typography variant="subtitle1" color="text.secondary">
                Notification Management
              </Typography>
            </Box>
            <Box>
              <Button variant='contained' startIcon={<DoneAll />} onClick={handleReadAll}>
                Read All
              </Button>
            </Box>
          </Box>
        </Box>

        {/* Filters Section */}
        <Card elevation={2} sx={{ mb: 3, borderRadius: '6px' }}>
          <CardContent>
            <Grid container spacing={2} alignItems="center">
              {/* <Grid item xs={12} md={3}>
                <TextField
                  fullWidth
                  placeholder="Search by Reference ID, Customer Name..."
                  value={searchQuery}
                  onChange={(e) => {
                    setSearchQuery(e.target.value);
                    setPage(1); // Reset to page 1 when searching
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Search />
                      </InputAdornment>
                    ),
                  }}
                  size="small"
                />
              </Grid> */}
              <Grid item xs={6} md={3}>
                <FormControl fullWidth size="small">
                  <Select
                    value={dateFilter}
                    onChange={handleDateFilterChange}
                    sx={{ borderRadius: '6px' }}
                  >
                    <MenuItem value="all">Date: All</MenuItem>
                    <MenuItem value="today">Today</MenuItem>
                    <MenuItem value="yesterday">Yesterday</MenuItem>
                    <MenuItem value="last_7_days">Last 7 Days</MenuItem>
                    <MenuItem value="custom">Custom Range</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={6} md={4}>
                <FormControl fullWidth size="small">
                  <Select
                    value={outletFilter}
                    disabled={JSON.parse(localStorage.getItem('admin_outlet_id')) ? true : false}
                    onChange={(e) => {
                      setOutletFilter(e.target.value);
                      setPage(1);
                    }}
                    sx={{ borderRadius: '6px' }}
                  >
                    <MenuItem value="all">Outlet: All</MenuItem>
                    {adminOutlets.map((outlet) => (
                      <MenuItem key={outlet.id} value={outlet.id}>
                        {outlet.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={6} md={2}>
                <FormControl fullWidth size="small">
                  <Select
                    value={typeFilter}
                    onChange={(e) => {
                      setTypeFilter(e.target.value);
                      setPage(1);
                    }}
                    sx={{ borderRadius: '6px' }}
                  >
                    <MenuItem value="all">Type: All</MenuItem>
                    <MenuItem value="Delivery">Delivery</MenuItem>
                    <MenuItem value="Reservation">Reservation</MenuItem>
                    <MenuItem value="Takeaway">Takeaway</MenuItem>
                    <MenuItem value="Contact">Contact</MenuItem>
                    <MenuItem value="Catering">Catering</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={6} md={2}>
                <FormControl fullWidth size="small">
                  <Select
                    value={isReadFilter}
                    onChange={(e) => {
                      setIsReadFilter(e.target.value);
                      setPage(1);
                    }}
                    sx={{ borderRadius: '6px' }}
                  >
                    <MenuItem value="all">All</MenuItem>
                    <MenuItem value="read">Read Only</MenuItem>
                    <MenuItem value="unread">Unread Only</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={1}>
                <Button
                  fullWidth
                  variant="outlined"
                  startIcon={<FilterList />}
                  onClick={clearFilters}
                  size="small"
                  sx={{ borderRadius: '6px' }}
                >
                  Clear
                </Button>
              </Grid>
            </Grid>

            {/* Custom Date Range Picker */}
            {dateFilter === "custom" && (
              <Box sx={{ mt: 2, p: 2, bgcolor: 'grey.50', borderRadius: '6px', border: '1px solid', borderColor: 'divider' }}>
                <Typography variant="subtitle2" fontWeight="medium" sx={{ mb: 2, color: 'text.primary' }}>
                  Select Date Range
                </Typography>
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={12} md={5}>
                    <DatePicker
                      label="Start Date"
                      value={dateRange.startDate}
                      onChange={(newValue) => setDateRange(prev => ({ ...prev, startDate: newValue }))}
                      format="dd-MM-yyyy"
                      slotProps={{
                        textField: {
                          fullWidth: true,
                          size: 'small',
                          InputProps: {
                            startAdornment: (
                              <InputAdornment position="start">
                                <CalendarToday fontSize="small" />
                              </InputAdornment>
                            ),
                          },
                          sx: {
                            borderRadius: '6px',
                            '& .MuiOutlinedInput-root': {
                              borderRadius: '6px',
                            }
                          }
                        }
                      }}
                      maxDate={dateRange.endDate || new Date()}
                    />
                  </Grid>
                  <Grid item xs={12} md={5}>
                    <DatePicker
                      label="End Date"
                      value={dateRange.endDate}
                      onChange={(newValue) => setDateRange(prev => ({ ...prev, endDate: newValue }))}
                      format="dd-MM-yyyy"
                      slotProps={{
                        textField: {
                          fullWidth: true,
                          size: 'small',
                          InputProps: {
                            startAdornment: (
                              <InputAdornment position="start">
                                <CalendarToday fontSize="small" />
                              </InputAdornment>
                            ),
                          },
                          sx: {
                            borderRadius: '6px',
                            '& .MuiOutlinedInput-root': {
                              borderRadius: '6px',
                            }
                          }
                        }
                      }}
                      minDate={dateRange.startDate}
                      maxDate={new Date()}
                      disabled={!dateRange.startDate}
                    />
                  </Grid>
                  {/* <Grid item xs={12} md={2}>
                    <Button
                      fullWidth
                      variant="contained"
                      onClick={() => setPage(1)}
                      disabled={!dateRange.startDate || !dateRange.endDate}
                      size="small"
                      sx={{
                        borderRadius: '6px',
                        height: '40px'
                      }}
                    >
                      Apply
                    </Button>
                  </Grid> */}
                </Grid>

                {dateRange.startDate && dateRange.endDate && (
                  <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                    Selected: {dateRange.startDate.toLocaleDateString('en-GB')} to {dateRange.endDate.toLocaleDateString('en-GB')}
                  </Typography>
                )}
              </Box>
            )}
          </CardContent>
        </Card>

        {/* Rest of your component remains the same */}
        {/* Notifications Table */}
        <Paper elevation={2} sx={{ borderRadius: '6px', overflow: 'hidden' }}>
          {loading ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 400 }}>
              <CircularProgress />
            </Box>
          ) : notificationData.length === 0 && !loading ? (
            <Box sx={{ p: 4, textAlign: 'center' }}>
              <Notifications sx={{ fontSize: 60, color: 'grey.400', mb: 2 }} />
              <Typography variant="h6" color="text.secondary">
                No notifications found
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Try adjusting your filters
              </Typography>
            </Box>
          ) : (
            <Box>
              <TableContainer>
                <Table stickyHeader>
                  <TableHead>
                    <TableRow sx={{ bgcolor: 'grey.100' }}>
                      {/* <TableCell sx={{ width: '25px', fontWeight: 'bold', color: 'text.secondary' }}>
                        STATUS
                      </TableCell> */}
                      <TableCell sx={{ width: '150px', fontWeight: 'bold', color: 'text.secondary' }}>
                        TYPE
                      </TableCell>
                      <TableCell sx={{ width: '150px', fontWeight: 'bold', color: 'text.secondary' }}>
                        OUTLET
                      </TableCell>
                      <TableCell sx={{ width: '120px', fontWeight: 'bold', color: 'text.secondary' }}>
                        TIME
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {notificationData.map((notification) => (
                      <TableRow
                        onClick={() => handleNotificationRead(notification.id, notification.type, notification.outlet_id)}
                        key={notification.id}
                        hover
                        sx={{
                          bgcolor: !notification.is_read ? 'action.hover' : "white",
                          cursor: 'pointer',
                          '&:hover': { bgcolor: 'action.hover' },
                          borderBottom: 1,
                          borderColor: 'divider'
                        }}
                      >
                        {/* <TableCell>
                          {!notification.is_read && (
                            <Circle sx={{ fontSize: 8, color: 'error.main' }} />
                          )}
                        </TableCell> */}
                        <TableCell>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <Avatar
                              sx={{
                                width: 30,
                                height: 30,
                                bgcolor: `${getTypeColor(notification.type)}.light`,
                                color: 'white'
                              }}
                            >
                              {getTypeIcon(notification.type)}
                            </Avatar>
                            <Typography variant="body2">
                              {notification.type}
                            </Typography>

                            <Typography>
                              {!notification.is_read && (
                                <Circle sx={{ fontSize: 8, color: 'error.main' }} />
                              )}</Typography>
                          </Box>
                        </TableCell>
                        <TableCell>
                          <Typography variant="body2" fontWeight="medium">
                            {adminOutlets?.find(o => o.id === notification.outlet_id)?.name || "Unknown Outlet"}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <AccessTime sx={{ fontSize: 16, color: 'text.secondary' }} />
                            <Typography variant="body2" color="text.secondary">
                              {new Date(notification.created_at).toLocaleString("en-GB", {
                                day: "2-digit",
                                month: "short",
                                year: "numeric",
                                hour: "2-digit",
                                minute: "2-digit",
                                hour12: true,
                              })}
                            </Typography>
                          </Box>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>

              {/* Pagination */}
              {notificationData.length > 0 && (
                <Box sx={{ p: 3, borderTop: 1, borderColor: 'divider' }}>
                  <Box sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    flexWrap: 'wrap',
                    gap: 2
                  }}>
                    {/* Left side - Rows per page selector */}
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <Typography variant="body2" color="text.secondary">
                        Rows per page:
                      </Typography>
                      <FormControl size="small" sx={{ minWidth: 80 }}>
                        <Select
                          value={rowsPerPage}
                          onChange={handleRowsPerPageChange}
                        >
                          {rowsPerPageOptions.map((option) => (
                            <MenuItem key={option} value={option}>
                              {option}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                      <Typography variant="body2" color="text.secondary">
                        Showing {startIndex} to {endIndex} of {totalCount} results
                      </Typography>
                    </Box>

                    {/* Right side - Pagination */}
                    <Stack direction="row" spacing={2} alignItems="center">
                      <Typography variant="body2" color="text.secondary">
                        Page {page} of {totalPages}
                      </Typography>
                      <Pagination
                        count={totalPages}
                        page={page}
                        onChange={handlePageChange}
                        color="primary"
                        size="small"
                        showFirstButton
                        showLastButton
                        disabled={loading}
                      />
                    </Stack>
                  </Box>
                </Box>
              )}
            </Box>
          )}
        </Paper>
      </Box>
    </LocalizationProvider>
  );
};

export default NotificationManagement;